module.exports = __webpack_public_path__ + "static/img/FIIlogo.df80226.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/SpecialFundsSelfInspection/img/FIIlogo.svg
// module id = quwM
// module chunks = 3